import React, { useEffect } from 'react'
import Recaptcha from 'react-recaptcha'

import config from '~config'

const CaptchaWidgetWrapper = ({ question }) => {
  useEffect(() => {
    question.value = null
  }, [])

  const verifyCallback = value => {
    question.value = value
  }

  return <Recaptcha sitekey={config.GOOGLE_RECAPTCHA_SITE_KEY} verifyCallback={verifyCallback} />
}

export default CaptchaWidgetWrapper
